import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import Notification from '../Common/Notification';
import { actions } from '../../actions/accountActions';
import ForgotPasswordForm from './ForgotPasswordForm';
import LoadingIndicator from '../Common/LoadingIndicator/LoadingIndicator';
import LoginStyleWrapper from '../Common/LoginStyleWrapper/LoginStyleWrapper';
import './ForgotPasswordPage.scss';

export class ForgotPasswordPage extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            username: '',
            error: '',
            isLoading: false,
            isSubmitted: false,
            isFormValid: true
        };
    }

    updateState = (event) => {
        this.setState({ error: '' });
        return this.setState({ username: event.target.value });
    }

    forgotPassword = async (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (this.state.username.trim().length < 1) {
            this.setState({ isFormValid: false });
            return;
        }

        try {
            this.setState({ isLoading: true });
            await this.props.actions.forgotPassword(this.state.username.trim())
            this.setState({ isSubmitted: true });
        } catch (error) {
            Notification("error", "Error", error);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    render() {
        return (
            <LoginStyleWrapper>
                <div className="container">
                    <LoadingIndicator isLoading={this.state.isLoading}>
                        <ForgotPasswordForm
                            username={this.state.username}
                            onSubmit={this.forgotPassword}
                            onChange={this.updateState}
                            isSubmitted={this.state.isSubmitted}
                            isFormValid={this.state.isFormValid}
                        />
                    </LoadingIndicator>
                </div>
            </LoginStyleWrapper>
        );
    }

}

ForgotPasswordPage.propTypes = {
    actions: PropTypes.object.isRequired
};

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({ ...actions }, dispatch)
    };
}

export default connect(null, mapDispatchToProps)(ForgotPasswordPage);